import { Stack } from "@mui/material";
import MediaInput from "components/files/MediaInput";

const Media = ({ clearErrors, setMedia1, setMedia2 }) => {

    return (
        <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            justifyContent="center"
            sx={{ flexWrap: 'wrap' }}
        >
            <MediaInput
                setCb={setMedia1}
                clearErrors={clearErrors}
                allowedFormats={["image", "video"]}
            />
            <MediaInput
                setCb={setMedia2}
                clearErrors={clearErrors}
                allowedFormats={["image", "video"]}
            />
        </Stack>
    );
};

export default Media;